import React, { Component } from "react";
import ReactDOM from 'react-dom'
import { Button, ButtonGroup,ButtonToolbar, Modal, PageHeader, SplitButton, DropdownButton, FormGroup, InputGroup, FormControl, MenuItem, ListGroup, ListGroupItem, Row, Col } from "react-bootstrap";
import { invokeApig }              from '../../libs/awsLib';
import { Link, Routes }            from 'react-router-dom'
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownClientAssessment from "../../components/utils/SortDropdownClientAssessment";
import RenderLander                from "../../components/utils/RenderLander";
import { handleGoToURL}            from "../../utils/URL";
import { getFiletypeIcon }         from "../../utils/Icons";
import uniqueId                    from "lodash/uniqueId";
import { createHTMLMarkup }        from "../../utils/HTML";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor }                  from 'react-draft-wysiwyg';
import htmlToDraft                 from 'html-to-draftjs';
import draftToHtml                 from 'draftjs-to-html';
import config                      from "../../config";
import { Colors }                  from "../../utils/Colors";
//import AssessmentEditor            from "../../components/assessment/AssessmentEditor";
import AutoSuggestClientName       from "../../components/AutoSuggestClientName";
import { getImgOrDocTag }          from "../../utils/ImageUpload";
import { s3Delete,
         // s3PublicUpload,
         // s3PublicGetImage
       } from "../../libs/awsLib";
//import { convertImageAttributes, compareExistingToNewImages } from "../../screens/assessment/utils";
import { invokeGetSummaryMessages,
         invokeSetMessageDelete,
         invokeGetMessageDetail,
         invokeSetMessageAdd,
         invokeSendNewTextMessage } from "../../utils/AwsInvoke";
import "../../css/message/MessageListAll.css";
import "../../css/form/Btn.css";
import '../../css/message/react-draft-wysiwyg.css';

const uuidv1 = require('uuid/v1');
const emptyTemplate = {"blocks":[{"key":"6t07u","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dsmoh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7kb5d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3d1uk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};
const prefix_file = "::file::";
const page_timer_secs = 15;
export default class MessageListall extends Component {
    constructor(props) {
        super(props);

        // HTML EDITOR //
        const html = '';
        const contentBlock = htmlToDraft(html);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);

        this.state = {
              isLoading: true, // default is true
              numberOfRows: 20,
              companyId: "9a7af3c4-97b1-11e7-9e5d-f78105fd617e",
              messageId: "new",
              recipientNameSearch: "",
              recipientId: "",
              recipientName: "",
              recipientPhone: "",
              rowHighlight: 1, // rows begin at el 1
              showLoadingBar:"none",
              sortBy: 1, // default sort by Name Asc
              pageOverlay: "none",
              inputValue: "",
              showDeleteConfirmWin: false,
              imgSetStateFlag: true,
              showMobileView: false,
              pageTimerSecs: page_timer_secs,
              beginProcessingImage: false, // do not start timer as default
              editorReadOnly: false,
              displayImageDeleteBtn: "none",
              loadingMsgText: "Retrieving messages ...",
              displayMessageBodyRightCol: "", // show message detail body at specific width
              imageSrcUrls: [require('../../images/icons/filetype/file.png')],
              messageBody: editorState //EditorState.createEmpty() //editorState
        };

        this.updateBrowserDimensions = this.updateBrowserDimensions.bind(this);
    }

    componentDidMount() {
        // Resource: https://www.hawatel.com/blog/handle-window-resize-in-react/
        /* TEMP removing while not using screen 6/23 */
        this.updateBrowserDimensions();
        // Resize function used for split screen view and to layer message details over message summaries
        window.addEventListener("resize", this.updateBrowserDimensions);


        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getMessagesList("Retrieving Messages ...");
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateBrowserDimensions);
    }

    updateBrowserDimensions() {
        //console.log("update BROWSER DIMENSIONS width: " + window.innerWidth);
        if(window.innerWidth < 990) {
            this.setState({
                showMobileView: true,

            });
        } else {
            // Guideline: Bootstrap col-sm-width = 890px
            this.setState({ showMobileView: false });
        }
    }

    getMessagesList = async (loadingMessage) => {
        console.log("Step 1. getMessagesList!!!");

        this.setState({
            loadingMsgText: loadingMessage,
            showLoadingBar: "inline"
        })

        var search_term    = "";
        var number_of_rows = this.state.numberOfRows;
        var creator_id     = this.props.globalUserId;

        const results = await invokeGetSummaryMessages(creator_id, search_term, number_of_rows);

        if(results) {
            let init_msg_id    = results.message_id[0];
            let init_fullname  = results.user_name[0];
            let init_user_id   = results.user_id[0];
            let init_user_phone = results.user_phone[0];

            const results2 = await invokeGetMessageDetail(creator_id, init_msg_id);

            if(results && results2) {

                    this.setState({
                        messages: results,
                        messageDetail: results2,
                        messageId: init_msg_id,
                        recipientId: init_user_id,
                        recipientName: init_fullname,
                        recipientPhone: init_user_phone,
                        isLoading: false,
                        showLoadingBar: "none"
                    });

                    //if(this.state.refreshPageTimer != false) {
                        //console.log("This should only be a set timer ONCE!");
                        //temp remove 9/19 this.startRefreshPageTimer("reset");
                    //}
            } else
                this.resetLoadingBar();
        }
    }

    clearSearchField = () => {
        this.searchInput.value = "";
    }

    searchMessages = async () => {
        this.setState({ showLoadingBar: "inline" })

        var search_term    = this.searchInput.value;
        var number_of_rows = this.state.numberOfRows;
        //var sort_by      = this.state.sortBy;
        var creator_id     = this.props.globalUserId;

        const results = await invokeGetSummaryMessages(creator_id, search_term, number_of_rows);

        if(results) {

            this.setState({
                messages: results,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    sortResults = (sort) => {
        // Sort: 1 = Filename: Asc | 2 = Filename: Desc | 3 = Filetype: Asc | 4 = Filetype: Desc

        this.setState({
            sortBy: sort,
            messages: null // reset messages object otherwise the messages list will re-render multiple times
        }, function(){
            this.getMessagesList("Sorting Message ...");
        })
    }

    handleKeyPress = (event) => {
        var search_term = event.target.value;

        // Allow user to hit "Enter" when using Search box //
        if(event.charCode === 13)
            this.searchMessages();

    }

    resetLoadingBar = () => {
        this.setState({ isLoading: false, showLoadingBar: "none" });
    }

    handleSubmitMessage = async () => {
        /* /* temp remove 8/29/19 */
        this.setState({ isLoading: true, showLoadingBar: "inline" });

        var body;
        var contentBlock;
        var recipient_id   = this.state.recipientId;
        var message_id     = this.state.messageId;
        var message_body   = this.state.messageBody;
        var creator_id     = this.props.globalUserId;


        ////  If there are any empty message bodies it will cause an error when calling message_body.getCurrentContent(); ////
        if(message_body != "") contentBlock = draftToHtml(convertToRaw(message_body.getCurrentContent()));
            else contentBlock = "";

        //// 8/29/19: Original s3PublicUpload file in /client_assets/_hold_files/awsLib-has-s3upload
        // temp remove because file upload is temp disabled 9/19: let photo_id = this.file ? await s3PublicUpload("messenger_files", this.file) : null;

        // If there's an eisting image and a new one hasn't been uploaded, use existing image
        //console.log("photo_id: " + photo_id);
        /*if(photo_id === null || photo_id === undefined) {
                photo_id = this.state.photo_id;*/

                if(contentBlock.trim() === "<p></p>") {
                    alert("Please enter a message.")
                    this.resetLoadingBar();
                } else {
                        let full_name  = this.state.recipientName;
                        let curr_phone = this.state.recipientPhone;
                        body = contentBlock; //this.state.messageBody;

                        const results = await invokeSetMessageAdd (creator_id, message_id, recipient_id, body);

                        if(results) {
                            // Reset Message Textfield
                            this.setState({
                                messageBody: "",
                                loadingMsgText: "Sending Message ...",
                                rowHighlight: 1, // reset row highlight
                            });

                            if(curr_phone != undefined) {
                                var digits = curr_phone.replace(/[^0-9]/g,"").length; // ensure this is a valid phone number

                                if(digits === 11) {
                                    //await invokeSendNewTextMessage(full_name, curr_phone);//"+14154255858"); //jack: "+14153174283"
                                }
                            }

                            // Reset Message Textfield
                            this.setState({
                                messageBody: "",
                                rowHighlight: 1, // reset row highlight
                            }, function(){
                                this.getMessagesList("Sending Message ...");
                            })
                        } else
                            this.resetLoadingBar();
                }
        /* // temp remove because file upload is temp disabled - temp remove 9/19:  } else {
            var file_type = this.state.fileType;
            body = prefix_file + file_type + "::" + photo_id;
            this.file = undefined; // reset file attachment otherwise submitting will continue to attach files

            this.setState({
                imageUploadSrc: "",
                displayImageDeleteBtn: "none",
                editorReadOnly: false,
                fileType: "",
                beginProcessingImage: true // begin timer
            });

            const results_message = await invokeSetMessageAdd (creator_id, message_id, recipient_id, body);

            if(results_message) {
                var profile_img_src = await s3PublicGetImage("messenger_files", photo_id);

                if(profile_img_src != "")
                    this.getMessagesList("Sending Message ...");
            }
        }
        /* */
    }

    handleShowMessageDetail = async (event, row_num, message_id, recipient_id, recipient_name, recipient_phone) => {
        //if(this.state.showMobileView)
        this.setState({
            displayMessageBodyRightCol: "inline",
            showLoadingBar: "inline"
        })

        // temp remove 9/26: this.props.hideNewMessageIcon(); // hide new message icon since user is on message list already
        var creator_id = this.props.globalUserId;

        ////  await for Results is only needed if there's a new message (red circle)
        ////  using await Results loads new message in the left col field and updates the latest text
        const results  = await invokeGetSummaryMessages(creator_id, "",  100);
        const results2 = await invokeGetMessageDetail(creator_id, message_id);

        if(results && results2) {
                this.setState({
                    messages: results, // updates new text from new msg if there available
                    messageId: message_id,
                    messageDetail: results2,
                    imgSetStateFlag: true,
                    recipientId: recipient_id,
                    recipientName: recipient_name,
                    recipientPhone: recipient_phone,
                    rowHighlight: row_num,
                    isLoading: false,
                    showLoadingBar: "none"
                });

                this.renderMessageDetail();
        } else
            this.resetLoadingBar();
    }

    handleNewMessage = () => {

        this.setState({
            messageDetail: "",
            messageId:     "new",
            rowHighlight:  0, // reset row highlight
            // reset state of new images when creating a new msg,
            // otherwise prev images will be cached and used in the new msg;
            imageSrcUrls:  [],
            recipientId:    this.props.globalUserTrainerId,
            recipientName:  this.props.globalUserTrainerName,
            recipientPhone: this.props.globalUserTrainerPhone,
            displayMessageBodyRightCol: "inline" // mobile device var
        });
    }

    handledeleteMessage = async (event, message_id, user_id) => {
        event.preventDefault();

        this.setState({
            loadingMsgText: "Deleting Message ...",
            showDeleteConfirmWin: true,
            pageOverlay: "inline",
            recipientId: user_id,
            messageId: message_id
        });
    }

    renderMessageList(messages) {

        var message_timer_text = "";//"Checking messages in " + this.state.pageTimerSecs + " secs.";

        var search_msg = <div key={uniqueId()} className="messageHeaderButtons">
                            <span style={{position:"relative", top:"7px", left:"7px"}}>
                             { /*tmp_search_msg*/ }
                            </span>
                            <span className="pull-left">
                                <Button className = "btnClientAddNe"
                                        onClick={(e) => this.handleNewMessage(e)}>
                                    New Msg
                                </Button>
                                <span style={{paddingTop:"5px", fontSize:"12px", paddingLeft:"20px"}}>
                                    { message_timer_text }
                                </span>
                            </span>
                            { /*}<span className="pull-right">
                                <SortDropdownClientAssessment sortResults={this.sortResults.bind(this)} />
                            </span>*/ }
                       </div>

         if(messages != null) {
                //// Check if Message is an image file ////
                //// Step 1. Convert Message to string, Step 2. Check if str is a file, Step 3. If so, show custom text "Attach..."
                //// messages.body[i-1].toString().match(/::file::/g) == "::file::" ? "Attachment: 1 file" : messages.body[i-1]

                var unread_msg_ids_arr  = this.props.unReadMessageIdsArray;

                return [{}].concat(messages.body).map(
                    (message, i) =>
                      i !== 0 ?
                            <div key={uniqueId()}
                                 className  = "grid messageListGrid "
                                 style      = {this.state.rowHighlight === i ? {backgroundColor:"#fdf7e1"} : {}}
                                 onClick    = {(e) => this.handleShowMessageDetail(e, i, messages.message_id[i-1], messages.user_id[i-1], messages.user_name[i-1])}
                            >
                                 <div style={{height:"32px"}}>
                                     <span className="pullLeft" style={{display:"inline-block", height:"25px", width:"70%", paddingLeft:"10px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", border:"0px solid #000"}}>
                                         <b>{ (unread_msg_ids_arr.includes(messages.message_id[i-1]) ? <span className="newSingleMessage"/> : null) }  { messages.user_name[i-1] } </b>
                                     </span>

                                     <span style={{float:"right",display:"inline-block",width:"70px", paddingRight:"10px",border:"0px solid #000"}}>
                                         {(new Date(messages.date[i-1])).toLocaleString('en-US', { month: 'short', day: 'numeric' })}
                                     </span>
                                 </div>
                                 <div className="messageListLeftColBodySummary">
                                     <div dangerouslySetInnerHTML={createHTMLMarkup( messages.body[i-1].toString().match(/::file::/g) == "::file::" ? "Attachment: 1 file" : messages.body[i-1] )} />
                                 </div>

                                 <span className="clientListRowRight" style={{float:"right",zIndex:1000,backgroundColor: "transparent"}}>
                                         <span className="messageListDeleteCol pullRight"
                                               onClick={(e) => this.handledeleteMessage(e, messages.id[i-1], messages.user_id[i-1])}>
                                             <span className="glyphicon glyphicon-remove-circle glyphiconMessgeListDeleteBtn" style={{color:"#ddd"}} />
                                         </span>
                                 </span>
                            </div>

                            :
                            <span key={uniqueId()} >
                                <div className="messageHeaderSearchBar">
                                    <span>
                                        <FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                                  {/*}<span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                                     />*/ }
                                               <InputGroup.Button>
                                                   <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchMessages()}>Search</Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                         </FormGroup>
                                     </span>
                                 </div>
                              { search_msg }

                              { i === 0 && messages.body == "" ?
                                    <ListGroupItem style={{height:422}}>
                                    You currently have 0 messages.
                                    </ListGroupItem>

                                : null }
                          </span>
                  );
             }
    }

    /*getAWSImgURL = async (aws_id) => {
        var img_url = await s3PublicGetImage("messenger_files", aws_id);

        var lgth = this.state.imageSrcUrls.length;
        console.log("Load image url: " + img_url);
        this.state.imageSrcUrls[lgth] = img_url
        this.setState({
            imageSrcUrls: this.state.imageSrcUrls
        })
    }*/

    /*startRefreshPageTimer(action) {
        console.log("BEGIN Timer -------------------------------------");
        var timer_secs = page_timer_secs; // seconds
        var timer;
        var that  = this;
        //clearInterval(timer);

        function startTimer () {
            timer = setInterval(function(){
                timer_secs--;
                that.setState({
                    pageTimerSecs: timer_secs,
                    refreshPageTimer: false //reset timer
                })
                //console.log("this.timer: " + timer_secs);
                if(timer_secs <= 0) {
                    console.log("finish!");
                    clearInterval(timer);
                    that.getMessagesList("Retrieving Message ... ")
                }
            }, 1000);
        }


        if(action === "reset") {
            console.log("RESET");
            clearInterval(timer);
            startTimer();
        }
    }*/

    getMediaFileDiv = (img_ctr, file_type, aws_id) => {
        var img_src = require('../../images/icons/filetype/file.png');
        var url     = this.state.imageSrcUrls[img_ctr];
        var media_file;

        file_type = file_type.toLowerCase();

        console.log("getmediafile URL: " + url + " :::: aws_id: " + aws_id);

        if(url === undefined) {
            if(this.state.beginProcessingImage) {
                console.log("START TIMER!!!");
                let promise = new Promise(function(resolve, reject) {
                    setTimeout(() => resolve(), 3000); // resolve runs the first function in .then below
                });

                promise.then(
                  result => { this.getAWSImgURL(aws_id) },
                  error => alert("Media upload error: " + error) // doesn't run
                );
                this.setState({
                    beginProcessingImage: false //reset timer
                })
            }

            media_file = <div className="blink"> Processing file ...</div>
        } else {
            if(file_type != "pdf" && file_type != "doc" && file_type != "mp4" && file_type != "mov" && file_type != "m4v")
                img_src = url;
              else if(file_type === "pdf") img_src = require('../../images/icons/filetype/pdf.png');
              else if(file_type === "doc") img_src = require('../../images/icons/filetype/doc.png');
              else if(file_type === "mp4" || file_type === "mov" || file_type === "m4v") img_src = require('../../images/icons/filetype/mp4.png')
              else img_src = url;

              media_file = <div onClick={ () => this.openMediaUrl(url)}>
                              <img src={img_src} style={{maxWidth:"150px", maxHeight:"80px"}}/>
                           </div>
          }

          return media_file;
    }

    openMediaUrl = async (url) => {
        window.open(url, "_blank")
    }

    renderMessageDetail = () => {
        var message      = this.state.messageDetail;
        var img_ctr = 0;

        if(message != null) {
            var lgth = Object.keys(message).length;
            var message_arr = [];
            var aws_img_id_arr = [];
            if(message[0] != undefined) {
                    var tmp_id = message[0].participant_id;
                    for(var i=0; i< lgth; i++) {
                        var member_id = message[i].participant_id;
                        var date = new Date(message[i].date_created).toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
                        var html_body = createHTMLMarkup(message[i].body);

                        //// Check if Message is an image file ////
                        var file_id = html_body.__html.toString(); // convert to string to check if msg is an image file
                        var file = file_id.match(/::file::/g);
                        var class_name;
                        var message_div; // a meesage will hold an image or text

                        if(member_id != tmp_id) {

                            class_name = "messageListBoxRight messageListSBRight";
                        } else {

                            class_name = "messageListBoxLeft messageListSBLeft";
                        }
                        //// IS THERE AN IMAGE | PDF | MOVIE IN THE FILE STRING
                        if(file == prefix_file) {

                            // Step 1. remove ::file_id:: from string
                            var file_ext = file_id.substring(file_id.indexOf(prefix_file)+8);

                            // Step 2. GET & REMOVE FILE TYPE/EXT
                            var file_type = file_ext.split("::")[0];

                            // Step 3. GET AWS FILE ID
                            var new_aws_id = file_ext.split("::")[1];

                            if(new_aws_id === undefined) new_aws_id = "";
                            //var image_id = this.getAWSImageID(prefix_file, new_aws_id)
                            aws_img_id_arr.push(new_aws_id);// hold image id in array to be used to call AWS urls

                            /* temp remove 9/25 but works fine: message_div = <div className={class_name} style={{paddingTop:"13px", paddingBottom:"10px"}}>
                                                {this.getMediaFileDiv(img_ctr++, file_type, new_aws_id) }
                                          </div>*/
                        } else {

                            message_div = <div className={class_name} dangerouslySetInnerHTML={html_body}></div>

                        }
                        message_arr.push(<div key={uniqueId()} >
                                                   { message_div }
                                                   <span style={{ display:"inline-block", position:"relative", top:"-63px", width:"100%", textAlign:"center", color:"#bbb", fontSize:"12px", float:"left"}}>
                                                       {date}
                                                   </span>
                                          </div>)
                    }
            }

            //// After all messages have been assigned to the array, fetch the AWS dynamic images //
            this.renderMessageImages(aws_img_id_arr)
            return message_arr;
        }
    }

    getAWSImageID = (prefix_file, html_str) => {
        // Parse image or video id
        var media_id = html_str.replace(prefix_file,'');
        return media_id;
    }

    renderMessageImages = async (aws_img_id_arr) => {
        /* temp remove 8/29/19
        var aws_lgth = aws_img_id_arr.length;
        var tmp_arr = [];

        //// Push entire AWS Image URL into array
        if(aws_lgth > 0) {
            for (let i = 0; i < aws_lgth; i++) {
                var media_id = aws_img_id_arr[i];
                var aws_file_url = await s3PublicGetImage("messenger_files", media_id);
                //console.log("aws_file_url: " + aws_file_url);
                tmp_arr.push(aws_file_url);
            }
        }

        if(this.state.imgSetStateFlag) {
            // Move this function to bottom of main Render, after ALL messages have been loaded
            // console.log("aws_lgth: " + aws_lgth);
            this.setState({
                imgSetStateFlag: false,
                imageSrcUrls: tmp_arr //sample: 'http://www.tompetty.com/sites/g/files/g2000007521/f/Sample-image10-highres.jpg'],
            })
        }*/
    }

    closeMessagesScreen  = (e) => {
        this.props.history.goBack();
    }

    /*handleRecipientNameChange  = (recipient_id, recipient_name, recipient_phone) => {
        this.setState({
            recipientNameSearch: recipient_name,
            recipientId: recipient_id,
            recipientPhone: recipient_phone
        });
    }*/


    scrollToBottomOfDiv() {
        //// If messages are long, scroll to bottom of message ////
        document.getElementById('scrollMessageDetailBody').scrollTop =  document.getElementById('scrollMessageDetailBody').scrollHeight;
    }

    componentDidUpdate() {
        this.scrollToBottomOfDiv();
    }

    handleFileChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.file = event.target.files[0];
            var tmp_file_name = this.file.name; // || .size || ".type"
            var file_type = tmp_file_name.substring(tmp_file_name.lastIndexOf(".")+1);

            if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
                alert(`Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE/1000000} MB.`);
                return;
            }
            file_type = file_type.toLowerCase();

            if(file_type === "jpg" || file_type === "jpeg" || file_type === "gif" || file_type === "png" ||
               file_type === "pdf" || file_type === "doc"  || file_type === "mp4" || file_type === "file" ||
               file_type === "mov" || file_type === "m4v") {
                    this.setState({
                        value: event.target.value
                    });

                    let reader = new FileReader();
                    var max_width = "120px";
                    var max_height = "120px";

                    if(file_type === "pdf" || file_type === "doc"  || file_type === "mp4" || file_type === "file" ||
                       file_type === "mov" || file_type === "m4v") {
                        max_width = "70px";
                        max_height = "70px";
                    }

                    reader.onload = (e) => {
                        var img_src_tmp = getImgOrDocTag(e.target.result, file_type, max_width, max_height);

                        this.setState({
                            imageUploadSrc: img_src_tmp,
                            fileType: file_type,
                            displayImageDeleteBtn: "inline",
                            editorReadOnly: true
                        });
                    };
                    reader.readAsDataURL(event.target.files[0]);
            } else {
                alert("Only images, .docs, .pdfs and .mp4s can be uploaded. Your filetype is " + file_type)
            }
        }
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            messageBody: editorState,
        });
     };

     handleShowMessageBodyLeftCol = () => {

        this.setState({
            displayMessageBodyRightCol: "none"
        });
     }

     handleDeleteAttachedFile = () => {
         this.file = undefined; // reset file attachment otherwise submitting will continue to attach files
         this.setState({
             displayImageDeleteBtn: "none",
             imageUploadSrc: "",
             editorReadOnly: false
         });
     }

     renderMessages() {

        var user = "All Members";
        var message      = this.state.messages;
        var message_detail;
        var recipient_textfield;
        //var recipient_id = this.state.recipientId;
        let to_textfield_ypos; // = "10px";
        var recipient_name           = this.state.recipientName;
        var editor_read_only         = this.state.editorReadOnly;
        var display_image_delete_btn = this.state.displayImageDeleteBtn;

        const editorState            = this.state.messageBody;

        if(message != undefined) {
            // If viewing a member's detail page, show fullname
            user =  <span className="" style={{cursor:"pointer"}}> { " " + message.user_name[0] } </span>
        }

        to_textfield_ypos = "20px";
        recipient_textfield =   <span   className="clientListRowMiddleLeft"
                                        style={{position:"relative", top: -1, fontSize:"22px"}}>
                                    <b className="pull-left">To: { recipient_name }</b>
                                </span>

        //// SHOW or HIDE the MESSAGE BODY LEFT & RIGHT COLUMNS
        var showMessageBodyRighttCol;//    = "inline";
        var showMessageBodyLeftCol;// = "none";
        var widthMessageLeftCol  = "50%";
        var widthMessageRightCol = "50%";
        var widthMessageNewMsgTF = "82%";
        var goBack;

        if(this.state.showMobileView) {
            if(this.state.displayMessageBodyRightCol === "inline") {
                widthMessageNewMsgTF     = "72%";
                widthMessageLeftCol      = "0%";
                widthMessageRightCol     = "100%";
                showMessageBodyLeftCol   = "none";
                showMessageBodyRighttCol = "inline-block";
                goBack = <span onClick={(e) => this.handleShowMessageBodyLeftCol(e)}>
                            <span className="glyphicon glyphicon-chevron-left " />
                        </span>
            } else { //if(this.state.)
                widthMessageLeftCol      = "100%";
                widthMessageRightCol     = "0%";
                showMessageBodyLeftCol   = "inline-block";
                showMessageBodyRighttCol = "none";
            }
        }

        return (
              <div className="programs-old">

                <span style={{position:"relative", fontWeight:"bold", top:"50px",fontSize:"30px",width:"100%", border:"0px solid #000"}}>
                    {/*}<div onClick={(e) => this.closeMessagesScreen(e)}
                          style={{position:"relative", top:"-10px", cursor:"pointer", fontSize:"17px"}}>
                          close [x]
                     </div>*/}
                     Messages <span style={{fontSize: "14px"}}> { /*this.props.globalUserEmail*/ }</span>
                </span>
                <p></p>
            <div className="container-flui" style={{position:"relative", top:"50px", zIndex:"999"}}>

                        { /*****************************************************************/ }
                        { /********************** 1. MESSAGE SUMMARIES *********************/ }
                        <span className="col-old messageListAllFromBody" //col-xs-12 col-sm-6 col-md-6
                              style = {{display: showMessageBodyLeftCol, border:"1px solid #ccc", width: widthMessageLeftCol}}>
                              {!this.state.isLoading && this.renderMessageList(message)}
                        </span>

                        { /*******************************************************************/ }
                        { /********************** 2. MESSAGE DETAIL BODY *********************/ }
                        <span className="col-old messageListAllBody" //hidden-xs col-sm-6 col-md-6
                              id="messageDetailBody" //showMessageDetail
                              style={{display: showMessageBodyRighttCol, width: widthMessageRightCol, border: "1px solid #ccc"}} >
                                <span className="messageListAllToContainer">
                                    <span className="messageListAllToTextfield" style={{position:"relative", top: to_textfield_ypos, left:"15px"}}>
                                        <span style={{paddingRight:"12px", cursor: "pointer", color:"#999"}}>
                                            { goBack }
                                        </span>
                                        <span className="messageRecipientTextfield" style={{width: widthMessageNewMsgTF}}>{ recipient_textfield }</span>
                                    </span>
                                </span>
                                <span id="scrollMessageDetailBody" className="messageListAllToBody" >

                                    {!this.state.isLoading && this.renderMessageDetail()}
                                </span>
                                <span className="messageListAllSearchBkgrd" style={{position:"absolute", left:"-16px", top:"380px", width:"104%", backgroundColor: "#fff"}}>
                                                 <Editor
                                                     editorState         = {editorState}
                                                     onEditorStateChange = {this.onEditorStateChange}
                                                     toolbarHidden       = { false }
                                                     editorStyle         = {{lineHeight: '100%'}}
                                                     readOnly            = { editor_read_only }
                                                     toolbar = {{
                                                           inline:    {
                                                               inDropdown: false,
                                                               options: [ /*'bold', 'italic', 'underline', /*'strikethrough', 'monospace'*/]
                                                           },
                                                           list:      { inDropdown: false },
                                                           textAlign: { inDropdown: false },
                                                           link:      { inDropdown: true },
                                                           history:   { inDropdown: false },
                                                           options:[ /*'inline','colorPicker',*/ 'emoji', 'link' ]
                                                     }}
                                                 />
                                                 <div className="formLabel pull-left"
                                                      onClick={(e) => this.handleDeleteAttachedFile(e)}
                                                      style={{display: display_image_delete_btn, position:"absolute", top:"53px", fontSize:"17px",left:"30px", cursor: "pointer", width:"100%", textAlign:"left"}}>
                                                     Delete [x]
                                                 </div>
                                                 <span className="formLabel pull-left" style={{position:"absolute", top:"83px", left:"30px", width:"100%", textAlign:"left"}}>
                                                     {this.state.imageUploadSrc}
                                                 </span>
                                                { /*} <span style={{position:"absolute", top:"3px", left:"127px"}}>
                                                           <label id="messageUploadFile" > File
                                                                   <FormControl onChange = {this.handleFileChange}
                                                                                style    = {{outline:"none", display: "none"  /*width = hide text: 'no file chosen' * /}}
                                                                                value    = {this.state.inputValue}
                                                                                type     = "file" />
                                                           </label>
                                                        </span>*/ }
                                                 <span className = "messageListSubmitBtn" >
                                                     <div className = "btnMessageListAllSubmit" style={{backgroundColor: Colors.search_button_bg}}
                                                          onClick={(e) => this.handleSubmitMessage(e)}>
                                                          Send
                                                             { /*}<span className="glyphicon glyphicon-upload glyphiconMsgListAllSendMessage"/>*/ }
                                                     </div>
                                                </span>
                                     </span>

                        </span>
                </div>
              </div>
        );

    }

    async deleteMessage () {
        this.setState({
            //pageOverlay: "inline",
            loadingMsgText: "Deleting Message ...",
            showDeleteConfirmWin: false,
            showLoadingBar: "inline"
        });

        var recipient_id  = this.state.recipientId
        var message_id    = this.state.messageId;
        var action        = ""; // other option: new
        var creator_id    = this.props.globalUserId;

        // Step 1. Delete Source File from AWS S3
        //const resultsDeleteFile = await s3Delete(this.state.assessmentId); // delete actual file from S3

        const results = await invokeSetMessageDelete(creator_id, message_id, recipient_id);

        if(results) {
            //var data     = results.data.client_data[0];
            //var content  = data.content;

            this.getMessagesList("Deleting Message ...");

            this.setState({pageOverlay: "none"})
            //<button onClick={() => this.scrollToBottomOfDiv()}>Scroll Down</button>

            /*let tmp_obj             = convertImageAttributes(content);
            let new_images_arr      = [];
            let existing_images_arr = tmp_obj.tmp_img_src_arr; //this.state.existingEditorImages;

            // DELETE ALL AWS S3 IMAGES
            // STEP 1. GET CONTENT OF JSON FILE from DB
            // STEP 2. EXTRACT AWS ID FROM "CONTENT"
            // STEP 3. DELETE AWS IMAGE FROM S3
            var compare = await compareExistingToNewImages(existing_images_arr, new_images_arr)

            if(compare) {
                // Step 4. Delete File Data from Database
                const resultsDeleteDBData = await invokeSetMessageDelete(, assessment_id);

                if(resultsDeleteDBData.status) {
                    this.getMessagesList();
                } else this.getMessagesList();
            }*/
        } else
            this.setState({pageOverlay: "none"})
    }

    handleCloseDeleteConfirmWin = (action) => {
        if(action === "delete") this.deleteMessage();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }

    render() {
        var loading_msg = this.state.loadingMsgText;
        return (
              <div className="ProgramList-old">
                {this.props.isAuthenticated ? this.renderMessages() : <RenderLander />}

                <FooterLoadingBar text={loading_msg}
                                  showLoadingBar={this.state.showLoadingBar}/>
                <div>
                        <span className="pageOverlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show={this.state.showDeleteConfirmWin}
                               onHide={() => this.handleCloseDeleteConfirmWin("close")}
                               aria-labelledby="contained-modal-title"
                               style={{position:"absolute", top:"10%", zIndex:10050}}
                             >
                               <Modal.Header closeButton>
                                 <Modal.Title id="contained-modal-title">
                                   Confirm Message Deletion
                                 </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                 Are you sure you want to delete this message PERMANENTLY?
                               </Modal.Body>
                               <Modal.Footer>
                                   <Button onClick={() => this.handleCloseDeleteConfirmWin("close")}>Close</Button>
                               <Button bsstyle="danger" onClick={() => this.handleCloseDeleteConfirmWin("delete")}>Yes, DELETE</Button>
                               </Modal.Footer>
                         </Modal>
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/message/MessageListAll.js